export enum ApiLogLevelEnum {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARN = 'WARN',
  SUCCESS = 'SUCCESS',
  DEBUG = 'DEBUG',
  OFF = 'OFF'
}
